/**
 * Curated listing categories. There is no public taxonomy API for
 * referral/discount verticals — this list is ours.
 *
 * "Other" is a form sentinel; the stored value is the custom text.
 */

export const CATEGORIES = [
  'Beauty',
  'Design',
  'Education',
  'Electronics',
  'Entertainment',
  'Fashion',
  'Finance',
  'Food & Drink',
  'Gaming',
  'Groceries',
  'Health & Wellness',
  'Home & Garden',
  'Insurance',
  'Music & Audio',
  'Pets',
  'Shopping',
  'Software',
  'Telecom',
  'Transport',
  'Travel',
] as const

export const CATEGORY_OTHER = '__other__'
